import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import PayAgain from "../../../../../RegisterLearningDetails/RegisterNowPay/PayAgain";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../CustomHelper/ContdownTimerRender";

const LiveChatActivity = ({ event, event_type, eventData = null }) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { countryDateTime } = useContext(LocationContext);

  const [liveSessionRoom, setLiveSessionRoom] = useState("");
  const [payAgin, setPayAgin] = useState(false);
  const [adminName, setAdminName] = useState();
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  useEffect(() => {

    if (event_type === "livechat") {
      axios.get(`api/user/live-chat/reg_info/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          setLiveSessionRoom(res.data.event);
          setAdminName(res.data.admin)
        }
      });
    }
  }, [event_type, event]);


  const event_start_time = moment(event.event_date).format("LL") + " " + liveSessionRoom.live_chat_start_time;
  const event_end_time = moment(event.event_date).format("LL") + " " + liveSessionRoom.live_chat_end_time;

  const event_start = new Date(countryDateTime(event_start_time, '')).getTime();
  const event_end = new Date(countryDateTime(event_end_time, '')).getTime();

  /**
   * video call join start
   */
  const [meetingJoin, setMeetingJoin] = useState(false);
  const history = useHistory();
  const JoinRoom = (roomId) => {
    setMeetingJoin(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`api/sdk/get-token/user`)
        .then((res) => {
          setMeetingJoin(false);
          const authName = localStorage.getItem("auth_name");

          history.push(
            `/video-meeting?token=${res.data.token}&meetingId=${roomId}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=false&canToggleWhiteboard=false&screenShareEnabled=false&askJoin=true&staradmin=${adminName}`
          );
          // window.location.href = ;
        });
    });
  };

  const JoinCall = (type) => {
    if (payStatus) {

      if (type === "liveChat") {
        JoinRoom(eventData?.room_id);
      }
    } else {
      alert('please select your current country')
    }
  };

  return (
    <>
      {liveSessionRoom ? (
        <>
          {event_start >= new Date().getTime() ? (
            <div class="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEn ">
                <img
                  src={imageCdnUrl + event.banner}
                  alt="Img1"
                  className="ImgAc"
                />

                <div className="joinNowBgLive title_text_ellipsis">
                  {event.title}
                </div>

                {liveSessionRoom?.publish_status !== 1 ? (
                  <h6
                    className="fw-bold pt-3 pb-1 text-warning EnHeadLive"
                    onClick={() => setPayAgin(true)}
                  >
                    <div class="spinner-grow text-warning" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>{" "}
                    Payment Pending
                  </h6>
                ) : (
                  <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLive">
                    Waiting
                  </h6>
                )}
                <Countdown
                  date={event_start}
                  renderer={ContdownTimerRender} />

              </div>
            </div>
          ) : event_start < new Date().getTime() &&
            event_end > new Date().getTime() ? (
            <div class="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEnLive ">
                <img
                  src={imageCdnUrl + event.banner}
                  alt="Img1"
                  className="ImgAc"
                />

                <div className="joinNowBg">Running...</div>

                <div className="joinNowBgLive title_text_ellipsis">
                  {event.title}
                </div>

                {event_type === "livechat" ? (
                  <>
                    {liveSessionRoom?.publish_status === 1 ? (
                      <a onClick={() => JoinCall("liveChat")}>
                        <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                          JOIN NOW{" "}
                          {meetingJoin && (
                            <i className="fas fa-spinner fa-pulse"></i>
                          )}
                        </h6>
                      </a>
                    ) : (
                      <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                        <i
                          class="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                        payment failed
                      </h6>
                    )}
                  </>
                ) : event_type === "learning_session" ? (
                  <Link
                    className="Link"
                    target="_blank"
                    to={{
                      pathname: `/learning-session/live_stream`,
                      search: `id=${event.room_id}`,
                    }}
                  >
                    <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                      JOIN NOW
                    </h6>
                  </Link>
                ) : event_type === "meetup" ? (
                  <a
                    className="Link"
                    target="_blank"
                    onClick={() => JoinCall("meetup")}
                  >
                    <h6 className="fw-bold pt-3 pb-1 text-warning EnHeadLiveActive">
                      JOIN NOW
                    </h6>
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <div class="col-md-6 col-lg-4 mb-3">
              <div className="card text-center CardEn">
                <img
                  src={imageCdnUrl + event.banner}
                  alt="Img1"
                  className="ImgAc"
                />

                <div className="joinNowBgLive title_text_ellipsis">
                  {event.title}
                </div>

                {event_type === "learning_session" &&
                  Number(event.assignment) === 1 &&
                  Number(event.status) === 5 ? (
                  <Link to={`/learning-activities/${event.slug}`}>
                    <h6 className="fw-bold pt-3 pb-1 text-light EnHeadLive">
                      Assignment
                    </h6>
                  </Link>
                ) : event_type === "learning_session" &&
                  Number(event.assignment) === 1 &&
                  Number(event.status) < 5 ? (
                  <h6 className="fw-bold pt-3 pb-1 text-danger EnHeadLive">
                    Assignment Pending
                  </h6>
                ) : (
                  <h6 className="fw-bold pt-3 pb-1 text-danger EnHeadLive">
                    Expired
                  </h6>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          class="spinner-border text-warning"
          role="status"
          style={{ marginLeft: "50px" }}
        >
          <span class="sr-only">Loading...</span>
        </div>
      )}
      {/* <PayAgain
        show={payAgin}
        onHide={() => setPayAgin(false)}
        event_id={event.id}
        event_type="livechat"
        fee={liveSessionRoom?.amount}
      /> */}

      <MyVerticallyCenteredModal
        show={payAgin}
        onHide={() => setPayAgin(false)}
        event_id={event.id}
        event_type="livechat"
        redirectTo="activities"
        fee={paymentCount(liveSessionRoom?.amount)}
        baseFee={liveSessionRoom?.amount}
      />
    </>
  );
};

export default LiveChatActivity;
